import { render } from "./Questionnaire.vue?vue&type=template&id=dbd4dc70&scoped=true&ts=true"
import script from "./Questionnaire.vue?vue&type=script&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&lang=ts"

import "./Questionnaire.vue?vue&type=style&index=0&id=dbd4dc70&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/Development/Stefania/assessment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd4dc70"]])

export default __exports__